module.exports = "<symbol id=\"thebestco-uikit-svg-Vote\" viewBox=\"0 0 20 18\"><path clip-rule=\"evenodd\" d=\"M10 1L1 12H7V17H13V12H19L10 1Z\"/></symbol>";